
import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

const ServicesPage = () => {
  const [expandedService, setExpandedService] = useState<number | null>(null);

  const services = [
    {
      title: '4x4 Services',
      icon: 'ri-car-line',
      description: 'Complete 4x4 and all-wheel drive system diagnostics, repair, and maintenance services.',
      details: 'Our 4x4 services include transfer case repair, differential service, driveline diagnostics, and complete four-wheel drive system maintenance to keep your vehicle performing in all conditions.'
    },
    {
      title: 'Air Conditioning',
      icon: 'ri-temp-cold-line',
      description: 'A/C system diagnosis, repair, recharge, and maintenance services.',
      details: 'We provide complete air conditioning services including refrigerant recharge, compressor repair, leak detection, evaporator and condenser service, and climate control system diagnostics.'
    },
    {
      title: 'Alignments',
      icon: 'ri-steering-2-line',
      description: 'Precision wheel alignment services for optimal tire wear and handling.',
      details: 'Our computerized alignment services ensure proper wheel angles, even tire wear, improved fuel economy, and better vehicle handling. We perform 2-wheel and 4-wheel alignments for all vehicle types.'
    },
    {
      title: 'Alternator',
      icon: 'ri-flashlight-line',
      description: 'Alternator testing, repair, and replacement services.',
      details: 'We diagnose charging system problems, test alternator output, replace worn alternators, and ensure your electrical system maintains proper voltage for reliable vehicle operation.'
    },
    {
      title: 'Axles',
      icon: 'ri-settings-3-line',
      description: 'CV axle and drive axle repair and replacement.',
      details: 'Complete axle services including CV joint replacement, axle shaft repair, boot replacement, and driveline component service for front-wheel, rear-wheel, and all-wheel drive vehicles.'
    },
    {
      title: 'Batteries',
      icon: 'ri-battery-charge-line',
      description: 'Battery testing, service, and replacement.',
      details: 'We test battery condition, clean terminals, check charging system performance, and install quality replacement batteries with warranty coverage for reliable starting power.'
    },
    {
      title: 'Brakes',
      icon: 'ri-brake-line',
      description: 'Complete brake system repair including pads, rotors, and hydraulics.',
      details: 'Full brake services including pad and rotor replacement, caliper service, brake fluid flush, ABS diagnostics, parking brake adjustment, and complete hydraulic system repair for safe stopping power.'
    },
    {
      title: 'Carburetors',
      icon: 'ri-gas-station-line',
      description: 'Carburetor cleaning, adjustment, and rebuild services.',
      details: 'Expert carburetor service including cleaning, rebuilding, adjustment, and tuning for classic and older vehicles to ensure proper fuel delivery and engine performance.'
    },
    {
      title: 'Check Engine Light',
      icon: 'ri-error-warning-line',
      description: 'Diagnostic services for check engine light and warning indicators.',
      details: 'We use advanced diagnostic equipment to read trouble codes, identify the root cause of check engine lights, and provide accurate repairs to resolve emission and performance issues.'
    },
    {
      title: 'Clutches',
      icon: 'ri-settings-4-line',
      description: 'Clutch repair and replacement for manual transmission vehicles.',
      details: 'Complete clutch services including clutch disc, pressure plate, and flywheel replacement, hydraulic system repair, and clutch adjustment for smooth shifting and reliable operation.'
    },
    {
      title: 'Computer Diagnostics',
      icon: 'ri-computer-line',
      description: 'Advanced computerized vehicle diagnostics and programming.',
      details: 'State-of-the-art diagnostic services using factory-level scan tools to diagnose engine, transmission, ABS, airbag, and all vehicle computer systems for accurate problem identification.'
    },
    {
      title: 'Cooling System/Radiators',
      icon: 'ri-temp-hot-line',
      description: 'Cooling system service, radiator repair, and thermostat replacement.',
      details: 'Complete cooling system services including radiator repair and replacement, water pump service, thermostat replacement, coolant flush, hose replacement, and overheating diagnostics.'
    },
    {
      title: 'Diesel Service',
      icon: 'ri-oil-line',
      description: 'Specialized diesel engine repair and maintenance.',
      details: 'Expert diesel services including fuel system repair, glow plug replacement, diesel particulate filter service, turbocharger repair, and complete diesel engine diagnostics and maintenance.'
    },
    {
      title: 'Drive Train',
      icon: 'ri-roadster-line',
      description: 'Driveline component repair and service.',
      details: 'Complete drivetrain services including driveshaft repair, U-joint replacement, differential service, transfer case repair, and all driveline component maintenance.'
    },
    {
      title: 'Electrical',
      icon: 'ri-lightbulb-line',
      description: 'Complete electrical system diagnosis and repair.',
      details: 'Full electrical services including wiring repair, starter replacement, lighting system repair, power window and lock repair, and complete electrical system diagnostics.'
    },
    {
      title: 'Engines',
      icon: 'ri-car-washing-line',
      description: 'Engine repair, rebuild, and replacement services.',
      details: 'Comprehensive engine services including engine diagnostics, cylinder head repair, engine rebuild, complete engine replacement, and performance upgrades for all makes and models.'
    },
    {
      title: 'Exhaust/Mufflers',
      icon: 'ri-contrast-drop-2-line',
      description: 'Exhaust system repair and muffler replacement.',
      details: 'Complete exhaust services including muffler replacement, catalytic converter service, exhaust pipe repair, manifold repair, and emission system diagnostics.'
    },
    {
      title: 'Fleet Service',
      icon: 'ri-truck-line',
      description: 'Commercial fleet maintenance and repair programs.',
      details: 'Specialized fleet services including scheduled maintenance programs, fleet vehicle repair, commercial truck service, and comprehensive fleet management solutions.'
    },
    {
      title: 'Fluid Flushes',
      icon: 'ri-drop-line',
      description: 'Complete fluid exchange services for all vehicle systems.',
      details: 'Professional fluid services including transmission flush, coolant flush, brake fluid flush, power steering flush, and differential fluid service to maintain system performance.'
    },
    {
      title: 'Fuel System',
      icon: 'ri-gas-station-fill',
      description: 'Fuel injection cleaning and fuel system repair.',
      details: 'Complete fuel system services including fuel injector cleaning, fuel pump replacement, fuel filter service, and fuel system diagnostics for optimal engine performance.'
    },
    {
      title: 'Inspection/Diagnostics',
      icon: 'ri-search-eye-line',
      description: 'Comprehensive vehicle inspections and diagnostic services.',
      details: 'Thorough inspection services including pre-purchase inspections, maintenance inspections, state inspections, and complete vehicle diagnostics to identify current and potential issues.'
    },
    {
      title: 'Lights',
      icon: 'ri-lightbulb-flash-line',
      description: 'Headlight, taillight, and lighting system repair.',
      details: 'Complete lighting services including headlight restoration, bulb replacement, LED upgrades, lighting system diagnostics, and turn signal repair for improved visibility and safety.'
    },
    {
      title: 'Oil Change',
      icon: 'ri-oil-line',
      description: 'Professional oil change services with quality filters and fluids.',
      details: 'Expert oil change services using premium oils and filters, including conventional, synthetic blend, and full synthetic options. Includes multi-point inspection and fluid top-off.'
    },
    {
      title: 'Overhaul',
      icon: 'ri-tools-fill',
      description: 'Complete engine and transmission overhaul services.',
      details: 'Major overhaul services including complete engine rebuild, transmission overhaul, and comprehensive restoration of major vehicle systems to factory specifications.'
    },
    {
      title: 'Pre-Purchase Inspection',
      icon: 'ri-file-list-3-line',
      description: 'Detailed inspection before buying a used vehicle.',
      details: 'Comprehensive pre-purchase inspection covering engine, transmission, brakes, suspension, electrical systems, and overall vehicle condition to help you make an informed buying decision.'
    },
    {
      title: 'Shocks and Struts',
      icon: 'ri-speed-up-line',
      description: 'Shock absorber and strut replacement services.',
      details: 'Complete suspension services including shock and strut replacement, suspension component inspection, and ride quality restoration for improved handling and comfort.'
    },
    {
      title: 'Speedometers',
      icon: 'ri-dashboard-line',
      description: 'Speedometer and instrument cluster repair.',
      details: 'Instrument cluster services including speedometer repair, gauge diagnostics, odometer service, and dashboard warning light diagnostics for accurate vehicle information.'
    },
    {
      title: 'State Inspections/Emissions',
      icon: 'ri-shield-check-line',
      description: 'Official state safety and emissions inspections.',
      details: 'Certified state inspection services including safety inspections, emissions testing, and all required state vehicle inspections to keep your vehicle legal and roadworthy.'
    },
    {
      title: 'Steering and Suspension',
      icon: 'ri-steering-line',
      description: 'Complete steering and suspension system repair.',
      details: 'Full steering and suspension services including power steering repair, tie rod replacement, ball joint service, control arm replacement, and complete suspension system diagnostics.'
    },
    {
      title: 'Timing Belts',
      icon: 'ri-time-line',
      description: 'Timing belt replacement and related component service.',
      details: 'Critical timing belt services including belt replacement, water pump service, tensioner replacement, and complete timing system service to prevent catastrophic engine damage.'
    },
    {
      title: 'Tires',
      icon: 'ri-wheel-line',
      description: 'Tire sales, mounting, balancing, and rotation services.',
      details: 'Complete tire services including new tire sales, mounting and balancing, tire rotation, flat repair, TPMS service, and tire pressure monitoring for optimal performance and safety.'
    },
    {
      title: 'Transmissions',
      icon: 'ri-settings-5-line',
      description: 'Transmission repair, rebuild, and replacement services.',
      details: 'Expert transmission services including diagnostics, fluid service, transmission repair, complete rebuild, and replacement for automatic and manual transmissions.'
    },
    {
      title: 'Tune Up',
      icon: 'ri-tools-line',
      description: 'Complete engine tune-up and maintenance services.',
      details: 'Comprehensive tune-up services including spark plug replacement, ignition system service, fuel system cleaning, and complete engine performance restoration.'
    },
    {
      title: 'Wheels',
      icon: 'ri-steering-2-fill',
      description: 'Wheel repair, replacement, and service.',
      details: 'Complete wheel services including wheel repair, replacement, balancing, and alignment to ensure proper fit, balance, and safe vehicle operation.'
    }
  ];

  const toggleService = (index: number) => {
    setExpandedService(expandedService === index ? null : index);
  };

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section 
        className="relative bg-cover bg-center bg-no-repeat h-96 flex items-center"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://public.readdy.ai/ai/img_res/9e38589af284b5c96da31d5f665f6c45.jpg')`
        }}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
          <div className="text-white">
            <nav className="text-sm mb-4">
              <Link to="/" className="text-gray-300 hover:text-white cursor-pointer">Home</Link>
              <span className="mx-2 text-gray-400">/</span>
              <span className="text-white">Services</span>
            </nav>
            <h1 className="text-5xl font-bold">Complete Auto Repair Services</h1>
            <p className="text-xl mt-4">Expert service for all makes and models in Passaic, NJ</p>
          </div>
        </div>
      </section>

      {/* Special Offers Section */}
      <section className="py-16 bg-gradient-to-br from-red-50 to-red-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">Special Offers</h2>
            <p className="text-xl text-gray-600">Save money on quality auto repair services</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* $25 Off Coupon */}
            <div className="bg-white rounded-2xl shadow-2xl p-8 relative overflow-hidden border-4 border-red-200 transform hover:scale-105 transition-transform duration-300">
              <div className="absolute top-0 right-0 bg-gradient-to-br from-yellow-400 to-yellow-500 text-red-800 px-6 py-3 font-bold text-lg transform rotate-12 translate-x-6 -translate-y-2 shadow-lg rounded-lg">
                SAVE $25
              </div>
              <div className="absolute top-4 left-4">
                <div className="w-8 h-8 bg-red-700 rounded-full"></div>
              </div>
              <div className="absolute bottom-4 right-4">
                <div className="w-6 h-6 bg-red-700 rounded-full"></div>
              </div>
              <div className="text-center mb-6 pt-4">
                <i className="ri-coupon-3-fill text-7xl text-red-700 mb-6"></i>
                <h3 className="text-4xl font-bold text-red-700 mb-2">$25 OFF</h3>
                <p className="text-2xl text-gray-800 font-semibold mb-4">Repairs Over $250</p>
                <div className="border-t-4 border-dashed border-red-300 my-6"></div>
                <div className="bg-red-50 rounded-lg p-4 mb-4">
                  <p className="text-lg font-bold text-red-800 mb-2">Code: SAVEWITHSAGIL</p>
                  <p className="text-sm text-gray-700">Mention this code at time of service. Cannot be combined with other offers. Valid on repairs totaling $250 or more.</p>
                </div>
              </div>
            </div>

            {/* Free Seasonal Checkup */}
            <div className="bg-white rounded-2xl shadow-2xl p-8 relative overflow-hidden border-4 border-blue-200 transform hover:scale-105 transition-transform duration-300">
              <div className="absolute top-0 right-0 bg-gradient-to-br from-blue-400 to-blue-500 text-white px-6 py-3 font-bold text-lg transform rotate-12 translate-x-6 -translate-y-2 shadow-lg rounded-lg">
                FREE
              </div>
              <div className="absolute top-4 left-4">
                <div className="w-8 h-8 bg-blue-600 rounded-full"></div>
              </div>
              <div className="absolute bottom-4 right-4">
                <div className="w-6 h-6 bg-blue-600 rounded-full"></div>
              </div>
              <div className="text-center mb-6 pt-4">
                <i className="ri-snowflake-fill text-7xl text-blue-600 mb-6"></i>
                <h3 className="text-3xl font-bold text-blue-700 mb-2">FREE Seasonal Checkup</h3>
                <p className="text-xl text-gray-800 font-semibold mb-4">Cold Weather Inspection</p>
                <div className="border-t-4 border-dashed border-blue-300 my-6"></div>
                <div className="bg-blue-50 rounded-lg p-4">
                  <ul className="text-left text-sm text-gray-700 space-y-3">
                    <li className="flex items-start">
                      <i className="ri-check-fill text-green-600 mr-3 mt-1 text-lg"></i>
                      <span className="font-medium">Coolant system inspection for proper operation</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-fill text-green-600 mr-3 mt-1 text-lg"></i>
                      <span className="font-medium">Hose and clamp inspection</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-fill text-green-600 mr-3 mt-1 text-lg"></i>
                      <span className="font-medium">Battery and charging system test</span>
                    </li>
                    <li className="flex items-start">
                      <i className="ri-check-fill text-green-600 mr-3 mt-1 text-lg"></i>
                      <span className="font-medium">Tire pressure and condition check</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* Free Oil Change */}
            <div className="bg-white rounded-2xl shadow-2xl p-8 relative overflow-hidden border-4 border-green-200 transform hover:scale-105 transition-transform duration-300">
              <div className="absolute top-0 right-0 bg-gradient-to-br from-green-400 to-green-500 text-white px-6 py-3 font-bold text-lg transform rotate-12 translate-x-6 -translate-y-2 shadow-lg rounded-lg">
                FREE
              </div>
              <div className="absolute top-4 left-4">
                <div className="w-8 h-8 bg-green-600 rounded-full"></div>
              </div>
              <div className="absolute bottom-4 right-4">
                <div className="w-6 h-6 bg-green-600 rounded-full"></div>
              </div>
              <div className="text-center mb-6 pt-4">
                <i className="ri-oil-fill text-7xl text-green-600 mb-6"></i>
                <h3 className="text-3xl font-bold text-green-700 mb-2">FREE Oil Change</h3>
                <p className="text-xl text-gray-800 font-semibold mb-4">With Service Over $1,000</p>
                <div className="border-t-4 border-dashed border-green-300 my-6"></div>
                <div className="bg-green-50 rounded-lg p-4 mb-4">
                  <p className="text-lg font-bold text-green-800 mb-2">Code: SAVEWITHSAGIL</p>
                  <p className="text-sm text-gray-700">Mention this code at time of service. Free conventional oil change with any service totaling $1,000 or more. Cannot be combined with other offers.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Content */}
      <section className="py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-12 text-center">
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Our Complete Service List</h2>
            <p className="text-lg text-gray-700 max-w-3xl mx-auto">
              Sagil Service offers comprehensive auto repair and maintenance services for all makes and models. 
              Click on any service below to learn more about what we offer.
            </p>
          </div>

          {/* Services List */}
          <div className="space-y-4">
            {services.map((service, index) => (
              <div key={index} className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200">
                <button
                  onClick={() => toggleService(index)}
                  className="w-full px-6 py-4 flex items-center justify-between hover:bg-gray-50 transition-colors cursor-pointer"
                >
                  <div className="flex items-center">
                    <div className="w-12 h-12 bg-red-700 rounded-full flex items-center justify-center mr-4">
                      <i className={`${service.icon} text-xl text-white`}></i>
                    </div>
                    <div className="text-left">
                      <h3 className="text-xl font-semibold text-gray-900">{service.title}</h3>
                      <p className="text-sm text-gray-600">{service.description}</p>
                    </div>
                  </div>
                  <i className={`ri-arrow-${expandedService === index ? 'up' : 'down'}-s-line text-2xl text-gray-400`}></i>
                </button>
                
                {expandedService === index && (
                  <div className="px-6 py-4 bg-gray-50 border-t border-gray-200">
                    <p className="text-gray-700 mb-4">{service.details}</p>
                    <div className="flex gap-4">
                      <Link 
                        to="/contact"
                        className="inline-flex items-center px-6 py-2 bg-red-700 hover:bg-red-600 text-white rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap text-sm"
                      >
                        <i className="ri-calendar-line mr-2"></i>
                        Schedule Service
                      </Link>
                      <a 
                        href="tel:(973) 472-0890"
                        className="inline-flex items-center px-6 py-2 bg-gray-700 hover:bg-gray-600 text-white rounded-lg font-semibold transition-colors cursor-pointer whitespace-nowrap text-sm"
                      >
                        <i className="ri-phone-line mr-2"></i>
                        Call Now
                      </a>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>

          {/* Quality Guarantee Section */}
          <div className="mt-16 bg-red-700 text-white rounded-lg p-8 text-center">
            <i className="ri-shield-check-fill text-6xl text-yellow-400 mb-4"></i>
            <h3 className="text-3xl font-bold mb-4">Quality Service Guarantee</h3>
            <p className="text-xl mb-2">We Stand Behind Our Work</p>
            <p className="text-lg">Your satisfaction is our commitment to excellence</p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gray-900 text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl font-bold mb-6">Need Service for Your Vehicle?</h2>
          <p className="text-xl mb-8 max-w-2xl mx-auto">
            Contact us today to schedule your service appointment. Our expert technicians are ready to help with all your automotive needs.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link 
              to="/contact" 
              className="inline-flex items-center px-8 py-4 bg-red-700 hover:bg-red-600 text-white text-lg font-semibold rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-calendar-line mr-2"></i>
              Schedule Service
            </Link>
            <a 
              href="tel:(973) 472-0890" 
              className="inline-flex items-center px-8 py-4 bg-red-700 hover:bg-red-600 text-white text-lg font-semibold rounded-lg transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              Call (973) 472-0890
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ServicesPage;
